import { render, staticRenderFns } from "./ViolationTypes.vue?vue&type=template&id=660d0ecb"
import script from "./ViolationTypes.vue?vue&type=script&lang=js"
export * from "./ViolationTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports